import { logUserOut } from "~/utils/logInCookiesCRUD";

export function useLogout() {
  const router = useRouter();

  const logout = async () => {
    try {
      // Wyloguj bez przekierowania - robimy to ręcznie
      await logUserOut({ redirect: false });
      // Użyj router.push zamiast window.location.href
      await router.push("/login");
    } catch (error) {
      console.error("Error during logout or redirection:", error);
      // Fallback - jeśli router zawiedzie, użyj window.location
      window.location.href = "/login";
    }
  };

  return {
    logout,
  };
}
